import React from 'react';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';

export default function Index() {
  return (
    <div className="content">
      <Row>
        <Col lg={{ span: 6, order: 'last' }}>
          <div className="bg-photo bg-managers-invite-success-photo" />
        </Col>

        <Col lg={{ span: 6, order: 'first' }}>
          <div className="py-4 px-sm-4 p-xxl-5">
            <h1 className="mb-5">Success!</h1>

            <p>Your members have been invited!</p>

            <p>
              Your Invitations have been sent to your members via email.
              After they receive it they’ll be able to onboard the LeggUP platform.
            </p>

            <p>
              They will create their own personal LeggUP account.
              This means that they will be able to view and manage their own Programs
              from anywhere at any time.
            </p>

            <a
              href={routes.managers.dashboard.index}
              className="btn btn-primary mt-4"
            >
              Close
            </a>
          </div>
        </Col>
      </Row>
    </div>
  );
}
